import { getWindow } from './global';

/**
 * Full-page navigations, grouped on one object so specs can observe them with
 * `jest.spyOn(browserNavigation, 'assign')`. jsdom 26 (Jest 30) makes `window.location` and its
 * methods unforgeable, so a spec can neither redefine `location` nor stub `location.assign`.
 * Call these instead of `window.location.*` (or assigning `location.href`) in code under test.
 */
export const browserNavigation = {
  assign(url: string | URL): void {
    getWindow()?.location.assign(url);
  },
  replace(url: string | URL): void {
    getWindow()?.location.replace(url);
  },
  reload(): void {
    getWindow()?.location.reload();
  },
};
